import './_cart-upsell.scss';
import component from './cart-upsell';

export default component;
